import * as React from "react"
import { Check, Minus } from "lucide-react"
import { cn } from "../../lib/utils"

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'checked' | 'onChange'> {
  checked?: boolean | 'indeterminate';
  onCheckedChange?: (checked: boolean) => void;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, checked, onCheckedChange, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onCheckedChange?.(e.target.checked);
    };

    return (
      <div className="relative inline-flex items-center">
        <input
          type="checkbox"
          ref={ref}
          checked={checked === 'indeterminate' ? false : checked}
          onChange={handleChange}
          className={cn(
            "h-4 w-4 shrink-0 rounded-sm border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 checked:bg-blue-600 checked:border-blue-600",
            className
          )}
          {...props}
        />
        {(checked === true || checked === 'indeterminate') && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            {checked === 'indeterminate' ? (
              <Minus className="h-3 w-3 text-white" />
            ) : (
              <Check className="h-3 w-3 text-white" />
            )}
          </div>
        )}
      </div>
    );
  }
);

Checkbox.displayName = "Checkbox";

export { Checkbox };
